// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon_icon__jkXet","icon--2x":"Icon_icon--2x__hXMHx","icon--6x":"Icon_icon--6x__qy2Rm","icon--20x":"Icon_icon--20x__DTIr7","transition":"Icon_transition__go6lz"};